const TASK_TYPE_CONFIG = {
  normal: { labelKey: 'task_type_normal', key: 'normal' },
  sac: { labelKey: 'task_type_sac', key: 'sac' },
  eepp: { labelKey: 'task_type_eepp', key: 'eepp' },
};

const resolveTaskType = (task) => {
  const name = (task?.nombre || task?.name || '').toUpperCase();
  if (name.includes('SAC') || name.includes('/SAC')) return 'sac';
  if (name.includes('EEPP') || name.includes('DP/') || name.includes('EST/')) return 'eepp';
  return 'normal';
};

const groupTasksByType = (tasks) => {
  const groups = { normal: [], sac: [], eepp: [] };
  (tasks || []).forEach((t) => {
    const type = resolveTaskType(t);
    groups[type].push(t);
  });
  return groups;
};

export { resolveTaskType, groupTasksByType, TASK_TYPE_CONFIG };
